import React, { useState, useEffect } from 'react';

import { Box } from '@chakra-ui/react';
import map from 'lodash/map';
import { useSelector } from 'react-redux';
import { customTheme } from '../../../../../../theme';

import { DashboardWidget } from 'components/Visualization/CDashboard/Widget/DashboardWidget';
import { BarChart } from 'components/Visualization/Charts';
import { customizedXAxisTick } from 'components/Visualization/Charts/utils';
import { renderCloudIcons } from 'containers/Dashboard/utils/utils';
import { commonVulnerabilityLineChartStyles } from 'containers/Visibility/Vulnerabilities/Components/styles';
import { selectVulnerabilities } from 'containers/Visibility/Vulnerabilities/selectors';

export const VulnerabilitiesBySources = () => {
  const { vulnerabilitiesBySources } = useSelector(selectVulnerabilities);
  const [data, setData] = useState<any>([]);

  useEffect(() => {
    const getName = (type: string) => {
      switch (type) {
        case 'ServerlessCompute':
          return 'Serverless';
        case 'VirtualMachine':
          return 'VM';
        default:
          return type;
      }
    };

    const items = map(vulnerabilitiesBySources.data?.items, o => ({
      name: getName(o.agnostic_name),
      Critical: o.vulnerability_count.critical,
      High: o.vulnerability_count.high,
      Medium: o.vulnerability_count.medium,
      Other:
        (o.vulnerability_count.low ?? 0) + (o.vulnerability_count.unknown ?? 0),
    }));

    setData(items);
  }, [vulnerabilitiesBySources.data]);

  return (
    <DashboardWidget
      label="Vulnerabilities by Sources"
      rightHeader={renderCloudIcons(vulnerabilitiesBySources.data?.clouds)}
      content={
        <Box w="full" h="full">
          <BarChart
            data={data}
            isLoading={vulnerabilitiesBySources.isLoading}
            xField="name"
            yField={['Critical', 'High', 'Medium', 'Other']}
            colorMap={{
              Critical: customTheme.colors.critical,
              High: customTheme.colors.high,
              Medium: customTheme.colors.medium,
              Other: customTheme.colors.gray['200'],
            }}
            styles={{
              ...commonVulnerabilityLineChartStyles,
              barChart: {
                margin: {
                  top: 0,
                  left: 0,
                  right: 10,
                  bottom: 0,
                },
              },
              xAxis: {
                ...commonVulnerabilityLineChartStyles.xAxis,
                interval: 0,
                tick: props =>
                  customizedXAxisTick({
                    ...props,
                    sliceLength: 14,
                    style: { fontSize: 14, y: 6 },
                  }),
              },
            }}
          />
        </Box>
      }
      styles={{ contentWrapper: { pl: 1, pt: 0, pb: 1 } }}
    />
  );
};
